import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=30fa5d47&scoped=true"
import script from "./partners.ts?vue&type=script&lang=ts&external"
export * from "./partners.ts?vue&type=script&lang=ts&external"
import style0 from "./partners.scss?vue&type=style&index=0&id=30fa5d47&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa5d47",
  null
  
)

export default component.exports